import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "CasinoMyGamesWidget" */ './CasinoMyGamesWidget'),
  modules: ['./CasinoMyGamesWidget'],
  loading: () => <div />
});

export default LoadableWidget;
